import React from "react";

const AboutV1 = () => {
  return (
    <div className="ltn__about-us-area pt-120 pb-90">
      <div className="container">
        <div className="row">
          <div className="col-lg-12">
            <div className="about-us-info-wrap">
              <div className="section-title-area mb-20">
                <h1 className="section-title">POLITIQUE DE CONFIDENTIALITÉ</h1>
                <p>
                  <strong>Dernière mise à jour : 25 mars 2026</strong>
                </p>
              </div>

              <div>
                <h4>1. INTRODUCTION</h4>
                <p>
                  Keurgui.sn (« nous », « notre ») respecte votre vie privée et
                  s’engage à protéger vos données personnelles. La présente
                  politique de confidentialité explique comment nous collectons,
                  utilisons et protégeons vos informations lorsque vous visitez
                  notre site web keurgui.sn (le « Site »).
                </p>

                <h4>2. RESPONSABLE DE TRAITEMENT</h4>
                <p>
                  Le responsable du traitement de vos données personnelles est :
                  <br />
                  Karone Suarl
                  <br />
                  Adresse : MAG, Guediawaye, Dakar, senegal
                  <br />
                  E-mail : legal@keurgui.sn
                </p>

                <h4>3. INFORMATIONS QUE NOUS COLLECTONS</h4>
                <p>
                  Nous pouvons collecter et traiter les données suivantes vous
                  concernant :
                </p>
                <ul>
                  <li>
                    <strong>Données d’identité :</strong> Nom, prénom,
                    identifiant similaire.
                  </li>
                  <li>
                    <strong>Données de contact :</strong> Adresse e-mail,
                    numéro de téléphone, adresse de livraison.
                  </li>
                  <li>
                    <strong>Données de transaction :</strong> Détails
                    concernant les paiements et les produits que vous avez
                    achetés.
                  </li>
                  <li>
                    <strong>Données techniques :</strong> Adresse IP, type de
                    navigateur, paramètres de fuseau horaire, système
                    d’exploitation.
                  </li>
                  <li>
                    <strong>Données d’utilisation :</strong> Informations sur
                    la façon dont vous utilisez notre site web.
                  </li>
                </ul>

                <h4>4. UTILISATION DE VOS INFORMATIONS</h4>
                <p>
                  Nous utilisons vos données personnelles pour les finalités
                  suivantes :
                </p>
                <ul>
                  <li>
                    Traiter et livrer vos commandes (y compris la confirmation
                    de paiement et les mises à jour de livraison).
                  </li>
                  <li>Gérer votre compte et fournir un support client.</li>
                  <li>
                    Améliorer notre site web, nos produits et services.
                  </li>
                  <li>
                    Respecter les obligations légales (exigences fiscales et
                    comptables).
                  </li>
                </ul>

                <h4>5. COOKIES</h4>
                <p>
                  Notre Site utilise des cookies pour vous distinguer des autres
                  utilisateurs. Cela nous permet de vous offrir une bonne
                  expérience de navigation et d’améliorer le Site. Vous pouvez
                  configurer votre navigateur pour refuser tous les cookies ou
                  certains d’entre eux.
                </p>

                <h4>6. PARTAGE DES DONNÉES</h4>
                <p>
                  Nous ne vendons pas vos données personnelles. Nous pouvons
                  partager vos données avec des tiers nécessaires à
                  l’exploitation de notre entreprise, notamment :
                </p>
                <ul>
                  <li>
                    <strong>Services de livraison :</strong> Pour assurer
                    l’acheminement de vos produits.
                  </li>
                  <li>
                    <strong>Processeurs de paiement :</strong> Pour gérer les
                    transactions en toute sécurité.
                  </li>
                  <li>
                    <strong>Prestataires informatiques :</strong> Qui gèrent
                    notre site web et le stockage des données.
                  </li>
                </ul>

                <h4>7. SÉCURITÉ DES DONNÉES</h4>
                <p>
                  Nous avons mis en place des mesures de sécurité appropriées
                  pour empêcher que vos données personnelles ne soient perdues
                  accidentellement, utilisées, consultées de manière non
                  autorisée, modifiées ou divulguées.
                </p>

                <h4>8. CONSERVATION DES DONNÉES</h4>
                <p>
                  Nous ne conservons vos données personnelles que le temps
                  nécessaire pour remplir les objectifs pour lesquels nous les
                  avons collectées, y compris pour satisfaire aux exigences
                  légales, comptables ou de déclaration.
                </p>

                <h4>9. VOS DROITS</h4>
                <p>
                  Conformément à la législation sénégalaise (Loi n° 2008-12 du
                  25 janvier 2008) et au RGPD (le cas échéant), vous disposez
                  des droits suivants :
                </p>
                <ul>
                  <li>
                    <strong>Droit d’accès :</strong> Demander l’accès à vos
                    données personnelles.
                  </li>
                  <li>
                    <strong>Droit de rectification :</strong> Demander la
                    correction de données inexactes.
                  </li>
                  <li>
                    <strong>Droit à l’effacement :</strong> Demander la
                    suppression de vos données.
                  </li>
                  <li>
                    <strong>Droit d’opposition :</strong> Vous opposer au
                    traitement de vos données à des fins de marketing.
                  </li>
                </ul>
                <p>
                  Pour exercer ces droits, veuillez nous contacter à{" "}
                  <a href="mailto:legal@keurgui.sn">legal@keurgui.sn</a>.
                </p>

                <h4>10. MODIFICATIONS DE CETTE POLITIQUE</h4>
                <p>
                  Nous pouvons mettre à jour cette politique de confidentialité
                  de temps à autre. Toute modification sera publiée sur cette
                  page avec une date de « Dernière mise à jour » actualisée.
                </p>

                <h4>11. NOUS CONTACTER</h4>
                <p>
                  Si vous avez des questions concernant cette politique de
                  confidentialité, veuillez nous contacter :
                  <br />
                  E-mail :{" "}
                  <a href="mailto:legal@keurgui.sn">legal@keurgui.sn</a>
                  <br />
                  Adresse : MAG, Guediawaye, Dakar, senegal
                </p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default AboutV1;